var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarForFilterTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.796 5.573l.122.269.294.023 3.8.302a.167.167 0 01.099.291s0 0 0 0L11.087 9.18l-.232.209.086.3 1.219 4.265s0 0 0 0a.168.168 0 01-.063.18l.295.405-.295-.404a.166.166 0 01-.19.004s0 0 0 0l-3.63-2.42L8 11.535l-.278.185-3.63 2.42h0a.166.166 0 01-.248-.078.166.166 0 01-.007-.098h0L4.83 9.66l.064-.274-.202-.196-2.809-2.738h0a.167.167 0 01.104-.286h0l3.8-.302.295-.023.121-.27 1.645-3.64V1.93a.165.165 0 01.302 0h0l.001.002 1.645 3.64z",
    fill: "#150223",
    stroke: "#150223"
  })));
}

export default SvgStarForFilterTag;